module.exports = __webpack_public_path__ + "img/home.28b1fbb1.svg";